// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2ZUB4","errorLogs":"styles_errorLogs__cE9L7"};